import "./App.css";
import About from "./Components/About";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";
import HeroSection from "./Components/HeroSection";
import Navbar from "./Components/Navbar";
import { BrowserRouter } from "react-router-dom";
import Work from "./Components/Work";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <div className="u-width">
        <HeroSection />
        <About />
        <Work />
        <Contact />
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
